import {
	ArrowCircleRightIcon,
	ArrowCircleLeftIcon,
	AtSymbolIcon,
	ChatIcon,
	MicrophoneIcon,
	ThumbUpIcon,
	PlayIcon,
	QuestionMarkCircleIcon,
	VideoCameraIcon,
} from "@heroicons/react/outline";

export const availableIcons = [
	{
		label: "Arrow right",
		value: "arrow_circle_right",
	},
	{
		label: "Arrow left",
		value: "arrow_circle_left",
	},
	{
		label: "At symbol (@)",
		value: "at_symbol",
	},
	{
		label: "Chat",
		value: "chat",
	},
	{
		label: "Microphone",
		value: "microphone",
	},
	{
		label: "Thumb up",
		value: "thumb_up",
	},
	{
		label: "Play",
		value: "play",
	},
	{
		label: "Question mark",
		value: "question_mark",
	},
	{
		label: "Video camera",
		value: "video_camera",
	},
];

export default function Icons({ icon }) {
	let svg;

	switch (icon) {
		case "arrow_circle_right":
			return <ArrowCircleRightIcon />;

		case "arrow_circle_left":
			return <ArrowCircleLeftIcon />;

		case "at_symbol":
			return <AtSymbolIcon />;

		case "chat":
			return <ChatIcon />;

		case "microphone":
			return <MicrophoneIcon />;

		case "thumb_up":
			return <ThumbUpIcon />;

		case "play":
			return <PlayIcon />;

		case "question_mark":
			return <QuestionMarkCircleIcon />;

		case "video_camera":
			return <VideoCameraIcon />;

		default:
			icon = "";
			break;
	}
	return <>{svg}</>;
}
